import React, { forwardRef, useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import html2pdf from "html2pdf.js";
import ReactECharts from "echarts-for-react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import { ReactComponent as VasanaLogo } from "../../../../assets/header/svg/vasana_logo.svg";
import { PhysicalOnePagerResultStyle } from "../PhysicalOnePagerResultStyle";
import VSNLoader from "../../../../shared/VSNLoader";
import VSNBreadcrumbs from "../../../../shared/VSNBreadcrumbs";
import VSNTypography from "../../../../shared/VSNTypography";
import {
  PurpalFlowerBullet,
  StarIcon,
  FrontLineLogo,
  ColoredArrow,
} from "../../../../shared/icon";
import SwiperCardComponent from "../../../assessment/SwiperCardComponent";
import VSNButton from "../../../../shared/VSNButton";
import CPETResults from "./CPETResults";
import EnergyUseDuringExercise from "./EnergyUseDuringExercise";
import YearOnYearComparison from "./YearOnYearComparison";
import LungHealthMeasurements from "./LungHealthMeasurements";
import {
  chartData,
  legends1,
  legends2,
  swiperData,
  yearOnYearoptionLegends1,
  yearOnYearoptionLegends2,
} from "./AssessmentConstant";
import { DynamicTable } from "./DynamicTable";
import VSNImage from "../../../../shared/VSNImage";
import CPETResultContainer from "../../../../container/CPET.container";
import {
  CPETGaugeCharts,
  CPETSecondChart,
  DynamicVO2Chart,
  EnergyUseChart,
  FlowChart,
  LungHealthMeasurementsTable,
  MetricChart,
  MetricTable,
  YearOnYearOptionChart,
} from "../../../assessment/CPETChartCommonComponent";
import {
  PDFHeader,
  PDFRecommendationSection,
} from "../PhysicalDashboardPDFCommonComponent";

const PrintComponent = forwardRef((props, ref) => {
  const classes = PhysicalOnePagerResultStyle();
  const { result, header } = props;
  const [reRender, setReRender] = useState(false);
  // useEffect(() => {
  //   setReRender(true);
  // }, []);

  return (
    <Box sx={{ visibility: "hidden", height: 0, overflow: "hidden" }}>
      <Box ref={ref}>
        <Box
          sx={{
            breack: "always",
            pageBreakAfter: "always",
          }}
        >
          <PDFHeader title="Your CPET, Explained" header={header} />

          <Stack
            className={classes.assessmentReportCard}
            sx={{
              background: "#FAF6F0 !important",
            }}
          >
            <VSNTypography
              variant="h3"
              component="h3"
              className={classes.mdHeadingprimary}
              mb={1}
              sx={{
                fontSize: "16px !important",
                color: "#B29263 !important",
                "&:before": { background: "#B29263 !important" },
              }}
            >
              Key Insights from Your CPET
            </VSNTypography>

            <Stack gap={1}>
              {result?.key_insights?.details?.map((el, index) => (
                <Stack direction="row" key={index}>
                  <Box sx={{ height: 12, width: 12 }} mr={2} mt={0.5}>
                    <StarIcon />
                    {/* <VSNImage src={result?.key_insights?.icon} /> */}
                  </Box>
                  <VSNTypography
                    display="inline"
                    fontWeight={700}
                    sx={{ marginRight: "4px" }}
                  >
                    {el?.title}
                  </VSNTypography>
                  <VSNTypography
                    sx={{
                      fontSize: "14px !important",
                      fontWeight: 500,
                      color: "#0A0A0B",
                      lineHeight: "24px",
                    }}
                  >
                    {el?.description}
                  </VSNTypography>
                </Stack>
              ))}
            </Stack>
          </Stack>

          <VSNTypography
            sx={{
              fontWeight: 700,
              fontSize: "24px",
              py: 2,
              color: "#8D6A3D",
            }}
          >
            {result?.cpet_result?.title ?? ""}
          </VSNTypography>

          <Stack
            sx={{ backgroundColor: "#FFFFFF" }}
            borderRadius="10px"
            gap={2}
          >
            <Stack direction="row" gap={2}>
              {result?.cpet_result?.gauge_charts?.map((item, index) => (
                <CPETGaugeCharts key={index} data={item} />
              ))}
            </Stack>

            <Stack direction="row" flexWrap="wrap" gap={2}>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing="8px"
              >
                <Stack height="100%" width="100%" justifyContent="center">
                  <Box
                    sx={{
                      backgroundColor: "#FDE9C8",
                      width: 16,
                      height: 16,
                      borderRadius: "4px",
                    }}
                  />
                </Stack>
                <VSNTypography fontSize="14px">Actual</VSNTypography>
              </Stack>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing="8px"
              >
                <Stack height="100%" width="100%" justifyContent="center">
                  <Box
                    sx={{
                      backgroundColor: "#C3EFD1",
                      width: 16,
                      height: 16,
                      borderRadius: "4px",
                    }}
                  />
                </Stack>
                <VSNTypography fontSize="14px">Predicted </VSNTypography>
              </Stack>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing="8px"
              >
                <Stack height="100%" width="100%" justifyContent="center">
                  <Box
                    sx={{
                      backgroundColor: "#34A259",
                      width: 16,
                      height: 16,
                      borderRadius: "4px",
                    }}
                  />
                </Stack>
                <VSNTypography fontSize="14px">Better</VSNTypography>
              </Stack>
            </Stack>
          </Stack>
        </Box>
        <Stack
          sx={{
            pageBreakAfter: "always",
            marginTop: "5px",
          }}
        >
          <DynamicTable tableData={result?.cpet_result?.table_data} />
        </Stack>
        <Stack
          sx={{ backgroundColor: "#FFFFFF", pageBreakAfter: "always" }}
          borderRadius="10px"
          gap={4}
        >
          {result?.cpet_result?.charts?.map((ele, index) => (
            <Stack
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                width: "100%",
              }}
              direction="row"
              key={index}
            >
              <Stack>
                <Stack direction="row" gap={2}>
                  <Stack pt={2} gap={1}>
                    <VSNTypography sx={{ fontSize: "18px", fontWeight: 700 }}>
                      {ele?.title}
                    </VSNTypography>

                    <VSNTypography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      {ele?.description}
                    </VSNTypography>
                    <VSNTypography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 700,
                        color: "var(--gray)",
                      }}
                      mt={2}
                    >
                      {ele?.info}
                    </VSNTypography>
                  </Stack>

                  {ele?.title === "Cardiac Output vs Oxygen Uptake" ? (
                    <Stack>
                      <CPETSecondChart
                        key={index}
                        chartData={ele}
                        height="240px"
                        width="415px"
                      />
                    </Stack>
                  ) : (
                    <Stack>
                      <DynamicVO2Chart
                        key={index}
                        chartData={ele}
                        height="240px"
                        width="415px"
                      />
                    </Stack>
                  )}
                </Stack>
              </Stack>
            </Stack>
          ))}
        </Stack>

        <Stack
          sx={{
            pageBreakAfter: "always",
          }}
        >
          <VSNTypography
            sx={{
              fontWeight: 700,
              fontSize: "24px",
              py: 2,
              color: "#8D6A3D",
            }}
          >
            {result?.energy_use_during_exercise?.title ?? ""}
          </VSNTypography>

          <Stack
            sx={{
              background: "#FAF6F0 !important",
            }}
            className={classes.assessmentReportCard}
          >
            <Stack gap={4}>
              <VSNTypography fontWeight={700}>
                {result?.energy_use_during_exercise?.description ?? ""}
              </VSNTypography>
            </Stack>
          </Stack>
          <Box sx={{ backgroundColor: "#FFFFFF" }} borderRadius="10px" pt={4}>
            <Stack gap={3}>
              <VSNTypography variant="h5" fontWeight={700} fontSize="24px">
                {result?.energy_use_during_exercise?.chart_title ?? ""}
              </VSNTypography>
              <Stack direction="row" gap={2} flexWrap="wrap">
                <Stack direction="row" gap={{ sm: 2, xs: 1 }} flexWrap="wrap">
                  {legends1?.map((item, index) => (
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing="8px"
                      key={index}
                    >
                      <Stack height="auto" width="auto" justifyContent="center">
                        <Box
                          sx={{
                            backgroundColor: item?.color,
                            width: 16,
                            height: 16,
                            borderRadius: "4px",
                          }}
                        />
                      </Stack>
                      <VSNTypography fontSize={{ xs: 14, sm: 16 }}>
                        {item?.label}
                      </VSNTypography>
                    </Stack>
                  ))}
                </Stack>
                <Stack
                  direction="row"
                  gap={{ sm: 2, xs: 1 }}
                  flexWrap="wrap"
                  mt={{ sm: 0, xs: 2 }}
                >
                  {legends2?.map((item, index) => (
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing="8px"
                      key={index}
                    >
                      <Stack height="auto" width="auto" justifyContent="center">
                        <Box
                          sx={{
                            backgroundColor: item?.color,
                            width: 16,
                            height: 16,
                            borderRadius: "4px",
                          }}
                        />
                      </Stack>
                      <VSNTypography>{item?.label}</VSNTypography>
                    </Stack>
                  ))}
                </Stack>
              </Stack>
            </Stack>

            <EnergyUseChart
              data={result?.energy_use_during_exercise}
              width="750px"
              height="400px"
            />

            <Stack
              direction="row"
              alignItems="center"
              sx={{
                transform: { xs: "scale(0.55)", md: "scale(0.49)" },
                transformOrigin: "top left",
                width: "100%",
              }}
              pt={6}
            >
              {chartData?.map((chart, index) => (
                <Stack
                  key={index}
                  direction="row"
                  alignItems="center"
                  className={classes.chartArrowWrapper}
                >
                  <Stack
                    className={classes.chartRound}
                    sx={{ backgroundColor: chart.color, color: "#fff" }}
                  >
                    {chart.label}
                  </Stack>
                  {chart.detail && (
                    <Stack
                      sx={{
                        position: "relative",
                        marginLeft: -5,
                      }}
                    >
                      <ColoredArrow color={chart.detailBgColor} />
                      <Stack
                        className={`${classes.chartDetails} detail`}
                        sx={{
                          color: chart.detailTextColor,
                        }}
                      >
                        {chart.detail}
                      </Stack>
                    </Stack>
                  )}
                </Stack>
              ))}
            </Stack>
          </Box>
        </Stack>

        {result?.year_on_year_comparison && (
          <Stack
            sx={{
              pageBreakAfter: "always",
            }}
          >
            <VSNTypography
              sx={{
                fontWeight: 700,
                fontSize: "24px",
                py: 2,
                color: "#8D6A3D",
              }}
            >
              {result?.year_on_year_comparison?.title ?? ""}
            </VSNTypography>

            <Stack
              sx={{
                background: "#FAF6F0 !important",
              }}
              className={classes.assessmentReportCard}
            >
              <Stack gap={4}>
                <VSNTypography fontWeight={700}>
                  {result?.year_on_year_comparison?.description ?? ""}
                </VSNTypography>
              </Stack>
            </Stack>
            <Box sx={{ backgroundColor: "#FFFFFF" }} borderRadius="10px" pt={4}>
              <Stack gap={3}>
                <VSNTypography variant="h5" fontWeight={700} fontSize="24px">
                  {result?.year_on_year_comparison?.chart_title ?? ""}
                </VSNTypography>
                <Stack direction="row" gap={2} flexWrap="wrap">
                  <Stack direction="row" gap={{ sm: 2, xs: 1 }} flexWrap="wrap">
                    {yearOnYearoptionLegends1?.map((item, index) => (
                      <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing="8px"
                        key={index}
                      >
                        <Stack
                          height="auto"
                          width="auto"
                          justifyContent="center"
                        >
                          <Box
                            sx={{
                              backgroundColor: item?.color,
                              width: 16,
                              height: 16,
                              borderRadius: "4px",
                            }}
                          />
                        </Stack>
                        <VSNTypography fontSize={{ xs: 14, sm: 16 }}>
                          {item?.label}
                        </VSNTypography>
                      </Stack>
                    ))}
                  </Stack>
                  <Stack
                    direction="row"
                    gap={{ sm: 2, xs: 1 }}
                    flexWrap="wrap"
                    mt={{ sm: 0, xs: 2 }}
                  >
                    {yearOnYearoptionLegends2?.map((item, index) => (
                      <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing="8px"
                        key={index}
                      >
                        <Stack
                          height="auto"
                          width="auto"
                          justifyContent="center"
                        >
                          <Box
                            sx={{
                              backgroundColor: item?.color,
                              width: 16,
                              height: 16,
                              borderRadius: "4px",
                            }}
                          />
                        </Stack>
                        <VSNTypography>{item?.label}</VSNTypography>
                      </Stack>
                    ))}
                  </Stack>
                </Stack>
              </Stack>

              <Stack direction="row" gap={2}>
                <YearOnYearOptionChart
                  data={
                    result?.year_on_year_comparison?.chart_data
                      ?.comparison_to_previous_1
                  }
                  height="380px"
                  width="380px"
                />
                <YearOnYearOptionChart
                  data={
                    result?.year_on_year_comparison?.chart_data
                      ?.comparison_to_previous_2
                  }
                  height="380px"
                  width="380px"
                />
              </Stack>

              <Box textAlign="center" mt={6}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {result?.year_on_year_comparison?.bar_values?.map(
                    (data, index) => (
                      <MetricChart
                        key={index}
                        metric={data.title}
                        currentValue={data.current}
                        pastValue={data.past}
                        unit={data.unit}
                        percentage={data?.percentage}
                        width="170px"
                      />
                    )
                  )}
                </Stack>
                <Box
                  mt={2}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center" mx={1}>
                    <Box width={12} height={12} bgcolor="#809dff" mr={1} />
                    <VSNTypography variant="body2">Past</VSNTypography>
                  </Box>
                  <Box display="flex" alignItems="center" mx={1}>
                    <Box width={12} height={12} bgcolor="#3b4a9f" mr={1} />
                    <VSNTypography variant="body2">Current</VSNTypography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Stack>
        )}

        {result?.year_on_year_comparison && (
          <Stack
            sx={{
              pageBreakAfter: "always",
              marginTop: "5px",
            }}
          >
            <VSNTypography
              sx={{
                fontWeight: 700,
                fontSize: "24px",
                py: 2,
                color: "#8D6A3D",
              }}
            >
              {result?.energy_use_during_exercise?.title ?? ""}etwetewtewtew
            </VSNTypography>
            <Stack sx={{ backgroundColor: "#FFFFFF" }} borderRadius="10px">
              <Stack gap={4}>
                {result?.year_on_year_comparison?.table?.map((rows, key) => {
                  return <MetricTable key={key} rows={rows} />;
                })}
              </Stack>
            </Stack>
          </Stack>
        )}

        <Stack
          sx={{
            pageBreakAfter: "always",
          }}
        >
          <VSNTypography
            sx={{
              fontWeight: 700,
              fontSize: "24px",
              color: "#8D6A3D",
            }}
          >
            Lung Health Measurements
          </VSNTypography>

          <Stack
            sx={{ backgroundColor: "#FFFFFF" }}
            borderRadius="10px"
            gap={2}
          >
            {result?.lung_health_measurements?.charts?.map((ele, index) => (
              <Stack
                sx={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  width: "100%",
                }}
                direction="row"
                key={index}
              >
                {ele?.title === "Pulmonary Metrics" ? (
                  <LungHealthMeasurementsTable
                    tableData={ele.data}
                    headers={ele.header}
                    pdf
                    title={ele.title}
                  />
                ) : (
                  <Stack direction="row" gap={2}>
                    <Stack pt={2} gap={1}>
                      <VSNTypography sx={{ fontSize: "18px", fontWeight: 700 }}>
                        {ele?.title}
                      </VSNTypography>

                      <VSNTypography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                        }}
                      >
                        {ele?.description}
                      </VSNTypography>
                      <VSNTypography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 700,
                          color: "var(--gray)",
                        }}
                        mt={2}
                      >
                        {ele?.info}
                      </VSNTypography>
                    </Stack>

                    {ele?.title === "Forced Vital Capacity" ? (
                      <Stack>
                        <FlowChart
                          key={index}
                          chartData={ele}
                          height="240px"
                          width="415px"
                        />
                      </Stack>
                    ) : (
                      <Stack>
                        <DynamicVO2Chart
                          key={index}
                          chartData={ele}
                          height="240px"
                          width="415px"
                        />
                      </Stack>
                    )}
                  </Stack>
                )}
              </Stack>
            ))}
          </Stack>
        </Stack>

        <Box
          sx={{
            pageBreakAfter: "always",
            marginTop: "10px",
          }}
        >
          <Stack
            className={classes.assessmentReportCard}
            sx={{
              background: "#FAF6F0 !important",
            }}
            mb={2}
          >
            <VSNTypography
              className={classes.mdHeadingprimary}
              sx={{
                fontSize: "16px !important",
                backgroundColor: "pink !importnant",
                color: "#B29263 !important",
                "&:before": { background: "#B29263 !important" },
              }}
            >
              {result?.expert_exercise_recommendations?.title ?? ""}
            </VSNTypography>
            <TableContainer
              sx={{
                backgroundColor: "#FAFAFA",
                borderRadius: 2,
                boxShadow: 3,
                marginTop: "16px",
              }}
            >
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={1}
                      align="center"
                      sx={{
                        width: 50,
                        backgroundColor: "#EAEAEC",
                        padding: 0,
                      }}
                    >
                      <VSNTypography
                        fontSize={16}
                        sx={{
                          fontWeight: "bold",
                          transform: "rotate(270deg)",
                        }}
                      >
                        ZONE 1
                      </VSNTypography>
                    </TableCell>
                    <TableCell align="center">
                      <AccessTimeIcon sx={{ color: "#8B3F9E" }} />
                    </TableCell>
                    <TableCell align="center">
                      <DirectionsBikeIcon sx={{ color: "#8B3F9E" }} />
                    </TableCell>
                    <TableCell align="center">
                      <DirectionsRunIcon sx={{ color: "#8B3F9E" }} />
                    </TableCell>
                  </TableRow>

                  {result?.expert_exercise_recommendations?.details
                    ?.filter((_, index) => index > 0)
                    ?.map((zone, index) => (
                      <TableRow key={index}>
                        <TableCell
                          align="center"
                          sx={{
                            width: "5%",
                            backgroundColor: zone.backgroundColor,
                            padding: 0,
                          }}
                        >
                          <VSNTypography
                            fontSize={16}
                            sx={{
                              color: zone.color,
                              fontWeight: "bold",
                              transform: "rotate(270deg)",
                            }}
                          >
                            {zone.title}
                          </VSNTypography>
                        </TableCell>
                        <TableCell align="center" sx={{ width: "22%" }}>
                          <VSNTypography variant="subtitle1">
                            {zone.intensity}
                          </VSNTypography>
                        </TableCell>
                        <TableCell align="center" sx={{ width: "31%" }}>
                          <VSNTypography variant="body2">
                            {zone.hr_watts}
                          </VSNTypography>
                        </TableCell>
                        <TableCell align="center" sx={{ width: "31%" }}>
                          <VSNTypography variant="body2">
                            {zone.hr}
                          </VSNTypography>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>

          <Stack
            className={classes.assessmentReportCard}
            sx={{
              background: "#FAF6F0 !important",
            }}
            mb={2}
          >
            <VSNTypography
              variant="h3"
              component="h3"
              className={classes.mdHeadingprimary}
              mb={1}
              sx={{
                fontSize: "16px !important",
                color: "#B29263 !important",
                "&:before": { background: "#B29263 !important" },
              }}
            >
              {result?.recommendations_acsm?.title ?? ""}
            </VSNTypography>

            <List
              className={classes.dailyFunctioning}
              sx={{
                background: "transparent !important",
                "&.MuiList-root": {
                  "& li": {
                    padding: "2px 10px",
                  },
                },
              }}
            >
              {result?.recommendations_acsm?.details?.map((el, index) => (
                <React.Fragment key={index}>
                  <ListItem key={index} p={0}>
                    <Box mr={2} mt={0.6}>
                      <PurpalFlowerBullet height="14" width="14" />
                    </Box>
                    <VSNTypography
                      sx={{
                        fontSize: "14px !important",
                        fontWeight: 500,
                        color: "#0A0A0B",
                        lineHeight: "24px",
                        paddingLeft: "0px !important",
                      }}
                    >
                      {el?.info}
                    </VSNTypography>
                  </ListItem>
                  {index === 0 && (
                    <VSNTypography marginLeft={5} fontWeight={700}>
                      OR
                    </VSNTypography>
                  )}
                </React.Fragment>
              ))}
            </List>
          </Stack>
        </Box>
        <PDFRecommendationSection
          data={result?.be_proactive ?? {}}
          staticData={swiperData}
        />
      </Box>
    </Box>
  );
});

const CPETDashboardResult = ({
  endPointToCall,
  showBreadCrumbs = true,
  breadCrumbAndButton,
  releaseButton,
  assessmentUserInfo,
  viewAllResult,
  from,
}) => {
  const classes = PhysicalOnePagerResultStyle();

  const {
    result: containerResult,
    loader,
    currentAssessment,
  } = from === "viewAll" ? {} : CPETResultContainer({ endPointToCall });

  const result = from === "viewAll" ? viewAllResult : containerResult;
  const printRef = useRef();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);

  const availableTabs = [];
  if (result?.cpet_result)
    availableTabs.push({
      label: "CPET Results",
      key: "cpet_result",
    });
  if (result?.energy_use_during_exercise)
    availableTabs.push({
      label: "Energy Use During Exercise",
      key: "energy_use_during_exercise",
    });
  if (result?.year_on_year_comparison)
    availableTabs.push({
      label: "Year-on-Year Comparison",
      key: "year_on_year_comparison",
    });
  if (result?.lung_health_measurements)
    availableTabs.push({
      label: "Lung Health Measurements",
      key: "lung_health_measurements",
    });

  const [currentData, setCurrentData] = useState(
    availableTabs.length > 0 ? result?.[availableTabs[0].key] : null
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCurrentData(result?.[availableTabs[newValue].key] || {});
  };

  useEffect(() => {
    if (result && availableTabs?.length > 0) {
      const firstAvailableKey = availableTabs.find(
        (tab) => result?.[tab.key]
      )?.key;
      setCurrentData(result?.[firstAvailableKey] || null);
    }
  }, [result, availableTabs.length]);

  const breadcrumbsRoutes = [
    {
      path: "/assessments",
      label: "Assessments",
    },
    {
      path: `/assessments/${currentAssessment?.assessment_id}`,
      label: `CPET Dashboard`,
    },
  ];

  const handleDownloadPDF = () => {
    setLoading(true);
    const element = printRef.current;

    const adminFilename = `${assessmentUserInfo?.name}_${assessmentUserInfo?.assessment_name}.pdf`;
    const userFilename = `${result?.info?.name}_${currentAssessment?.assessment_name}.pdf`;
    const fileName = assessmentUserInfo ? adminFilename : userFilename;

    const options = {
      margin: 4,
      filename: fileName,
      image: { type: "jpeg", quality: 0.7 },
      html2canvas: { scale: 1.6, useCORS: true, allowTaint: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        pdf.save(fileName);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const PDFDetails = assessmentUserInfo ?? result?.info;

  if (from !== "viewAll" && (loader?.assessmentResult || !currentData)) {
    return <VSNLoader variant="fullPage" />;
  }

  return (
    <div className={classes.mainLayout}>
      {from !== "viewAll" ? (
        showBreadCrumbs ? (
          <Box mt={2.5} mb={1.8}>
            <VSNBreadcrumbs {...{ breadcrumbsRoutes }} />
          </Box>
        ) : (
          <Box className={classes.headingButton}>
            <Box>{breadCrumbAndButton}</Box>
            <Stack direction="row" gap={2} alignItems="center">
              <VSNButton
                className={classes.PrintButton}
                handleClick={handleDownloadPDF}
                isLoading={loading}
              >
                <Stack
                  direction="row"
                  gap={{ sm: 2, xs: 1 }}
                  alignItems="center"
                  flexWrap="wrap"
                  sx={{ width: { xsm: "auto", xs: "100%" } }}
                >
                  <PrintOutlinedIcon />
                  Print CPET
                </Stack>
              </VSNButton>
              {currentData?.is_locked ? releaseButton : ""}
            </Stack>
          </Box>
        )
      ) : null}

      {result?.message === "No report found" ? (
        <Stack direction="row" justifyContent="center" p={5}>
          <VSNTypography variant="h5">No Report Found</VSNTypography>
        </Stack>
      ) : (
        <>
          {showBreadCrumbs && (
            <Stack
              direction={{ xsm: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <VSNTypography
                fontSize={{ xsm: 24, sm: 34 }}
                sx={{ fontWeight: 700 }}
              >
                {result?.title ?? ""}
              </VSNTypography>
              <VSNButton
                className={classes.PrintButton}
                handleClick={handleDownloadPDF}
                isLoading={loading}
              >
                <Stack direction="row" alignItems="center" gap={1}>
                  <PrintOutlinedIcon />
                  Print CPET Report
                </Stack>
              </VSNButton>
            </Stack>
          )}

          <PrintComponent ref={printRef} result={result} header={PDFDetails} />

          <Grid container spacing={3} mb={3}>
            <Grid item md={12} xs={12}>
              <Stack className={classes.assessmentReportCard}>
                <Box sx={{ display: "block" }}>
                  <VSNTypography
                    className={classes.mdHeadingMain}
                    dangerouslySetInnerHTML={{
                      __html: "Key Insights from Your CPET",
                    }}
                  />
                </Box>
                <Stack direction={{ md: "row" }}>
                  <Box flex={1}>
                    <List
                      className={
                        result?.key_insights?.length === 1
                          ? classes.notesListOne
                          : classes.notesList
                      }
                      sx={{ padding: "0px !important" }}
                    >
                      {result?.key_insights?.details?.map((el, index) => (
                        <React.Fragment key={index}>
                          <ListItem sx={{ width: { lg: "33% !important" } }}>
                            <VSNTypography
                              display="inline"
                              fontWeight={700}
                              sx={{ marginRight: "4px" }}
                            >
                              {el?.title}
                            </VSNTypography>
                            {el?.description}
                            {el?.icon && (
                              <VSNButton
                                sx={{
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  "&.MuiButtonBase-root": {
                                    background: "#8B3F9E",
                                    "& .content": {
                                      fontSize: 16,
                                      padding: "4px 8px",
                                      fontWeight: 400,
                                      textDecoration: "underline",
                                    },
                                  },
                                }}
                              >
                                {el?.icon}
                              </VSNButton>
                            )}
                          </ListItem>
                        </React.Fragment>
                      ))}
                    </List>
                  </Box>
                </Stack>
              </Stack>
            </Grid>
          </Grid>

          <Box sx={{ width: "100%" }} mb={3}>
            {/* <Tabs
              className={classes.CustomTabs}
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
                setCurrentData(tabs[newValue]?.data || {});
              }}
              sx={{ overflow: "auto" }}
            >
              {tabs.map((tab, index) => (
                <Tab key={index} disableRipple label={tab.label} />
              ))}
            </Tabs>

            {value === 0 && <CPETResults data={tabs[value]?.data} />}
            {value === 1 && (
              <EnergyUseDuringExercise data={tabs[value]?.data} />
            )}
            {result?.year_on_year_comparison && value === 2 && (
              <YearOnYearComparison data={tabs[value]?.data} />
            )}
            {value === tabs.length - 1 && (
              <LungHealthMeasurements data={tabs[value]?.data} />
            )} */}

            <Tabs
              className={classes.CustomTabs}
              value={value}
              onChange={handleChange}
            >
              {availableTabs?.map((tab, index) => (
                <Tab key={index} disableRipple label={tab.label} />
              ))}
            </Tabs>

            {availableTabs?.length > 0 && value < availableTabs?.length && (
              <>
                {availableTabs[value]?.key === "cpet_result" && (
                  <CPETResults data={currentData} />
                )}
                {availableTabs[value]?.key === "energy_use_during_exercise" && (
                  <EnergyUseDuringExercise data={currentData} />
                )}
                {availableTabs[value]?.key === "year_on_year_comparison" && (
                  <YearOnYearComparison data={currentData} />
                )}
                {availableTabs[value]?.key === "lung_health_measurements" && (
                  <LungHealthMeasurements data={currentData} />
                )}
              </>
            )}
          </Box>

          <Stack className={classes.assessmentReportCard} mb={3}>
            <Box mb={4} sx={{ display: "block" }}>
              <VSNTypography className={classes.mdHeadingMain}>
                {result?.expert_exercise_recommendations?.title ?? ""}
              </VSNTypography>
            </Box>
            <Grid container spacing={3}>
              <Grid item xl={6} lg={6} xs={12}>
                <TableContainer
                  sx={{
                    backgroundColor: "#FAFAFA",
                    borderRadius: 2,
                    boxShadow: 3,
                  }}
                >
                  <Table>
                    <TableBody>
                      {result?.expert_exercise_recommendations?.details
                        ?.filter((_, index) => index === 0)
                        .map((zone, index) => (
                          <TableRow key={index}>
                            <TableCell
                              align="center"
                              sx={{
                                width: "5%",
                                backgroundColor: zone.backgroundColor,
                                padding: 0,
                              }}
                            >
                              <VSNTypography
                                fontSize={{ sm: 16, xs: 14 }}
                                sx={{
                                  color: zone.color,
                                  fontWeight: "bold",
                                  transform: "rotate(270deg)",
                                  backgroundColor: zone.backgroundColor,
                                }}
                              >
                                {zone.title}
                              </VSNTypography>
                            </TableCell>
                            <TableCell align="center" sx={{ width: "22%" }}>
                              <VSNTypography variant="body2">
                                <VSNImage
                                  src={zone?.intensity_icon}
                                  alt="heading logo 1"
                                />
                              </VSNTypography>
                            </TableCell>
                            <TableCell align="center" sx={{ width: "31%" }}>
                              <VSNTypography variant="body2">
                                <VSNImage
                                  src={zone?.hr_watts_icon}
                                  alt="heading logo 2"
                                />
                              </VSNTypography>
                            </TableCell>
                            <TableCell align="center" sx={{ width: "31%" }}>
                              <VSNTypography variant="body2">
                                <VSNImage
                                  src={zone?.hr_icon}
                                  alt="heading logo 3"
                                />
                              </VSNTypography>
                            </TableCell>
                          </TableRow>
                        ))}

                      {result?.expert_exercise_recommendations?.details
                        ?.filter((_, index) => index > 0)
                        .map((zone, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:hover": {
                                backgroundColor: zone.backgroundColor,
                                "& .MuiTypography-root": { fontWeight: "bold" },
                              },
                            }}
                          >
                            <TableCell
                              align="center"
                              sx={{
                                width: "5%",
                                backgroundColor: zone.backgroundColor,
                                padding: 0,
                              }}
                            >
                              <VSNTypography
                                fontSize={{ sm: 16, xs: 14 }}
                                sx={{
                                  color: zone.color,
                                  fontWeight: "bold",
                                  transform: "rotate(270deg)",
                                }}
                              >
                                {zone.title}
                              </VSNTypography>
                            </TableCell>
                            <TableCell align="center" sx={{ width: "22%" }}>
                              <VSNTypography variant="subtitle1">
                                {zone.intensity}
                              </VSNTypography>
                            </TableCell>
                            <TableCell align="center" sx={{ width: "31%" }}>
                              <VSNTypography variant="body2">
                                {zone.hr_watts}
                              </VSNTypography>
                            </TableCell>
                            <TableCell align="center" sx={{ width: "31%" }}>
                              <VSNTypography variant="body2">
                                {zone.hr}
                              </VSNTypography>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xl={6} lg={6} xs={12}>
                <VSNTypography
                  variant="h6"
                  component="h6"
                  fontWeight={700}
                  mb={1}
                  fontSize={{ xs: 20, sm: 20 }}
                  lineHeight={1.5}
                >
                  {result?.recommendations_acsm?.title ?? ""}
                </VSNTypography>

                <List
                  className={classes.dailyFunctioning}
                  sx={{
                    background: "transparent !important",
                    "&.MuiList-root": {
                      "& li": {
                        padding: "2px 10px",
                      },
                    },
                  }}
                >
                  {result?.recommendations_acsm?.details?.map((el, index) => (
                    <React.Fragment key={index}>
                      <ListItem key={index} p={0}>
                        <Box mt={0.5}>
                          <PurpalFlowerBullet />
                        </Box>
                        <VSNTypography color="secondary.main">
                          {el?.info}
                        </VSNTypography>
                      </ListItem>
                      {index === 0 && (
                        <VSNTypography marginLeft={5} fontWeight={700}>
                          OR
                        </VSNTypography>
                      )}
                    </React.Fragment>
                  ))}
                </List>
              </Grid>
            </Grid>
          </Stack>

          <SwiperCardComponent
            title={result?.be_proactive?.title}
            description={result?.be_proactive?.description}
            data={result?.be_proactive?.recommendations ?? []}
          />
        </>
      )}
    </div>
  );
};

export default CPETDashboardResult;
